import { useEffect, useState } from 'react';
import { FaBook, FaMinus, FaPlus, FaUserFriends } from 'react-icons/fa';
import { MdAddCircle, MdDelete } from 'react-icons/md';
import styles from "./catalogs.module.css";
import { api } from '../../utils/services/api';
import { SERVICE } from '../../utils/constants/services';
import Swal from 'sweetalert2';
import Select from 'react-select';
import WindowLayout from '../../utils/layout/windowsLayout';

export default function Catalogos(props) {
    const [roles, setRoles] = useState([]);
    const [elementsAll, setElementAll] = useState([]);
    const [permitions, setPermitions] = useState([]);
    const [elementsUser, setElementUser] = useState([]);

    const [rolSelect, setRolSelect] = useState(null);



    const handleAddElementUser = (elementId) => {
        if(rolSelect!=null){
            let payload = {
                roleId: rolSelect.id,
                elementId: elementId
            }
            api(SERVICE.setPermision,payload,"POST")
                .then((data) => {
                    handleUpdatePermision();
                })
                .catch((err) => {
    
                })
        }
        
    }
    const handleDeleteElementUser = (elementId) => {
        if(rolSelect!=null){
            let searchElement = permitions.findIndex(item => item.elementId === elementId && item.roleId === rolSelect.id);
            if(searchElement !== -1){
                api(SERVICE.deletePermision + `?PermissionsId=${permitions[searchElement].id}`, {}, "DELETE")
                .then((data) => {
                    handleUpdatePermision();
                })
                .catch((err) => {
    
                })
            }
            
        }
        
    }
    const handleUpdatePermision = () => {
        api(SERVICE.getPermision)
            .then((data) => {
                let arrayTemp = [];
                if(data.data.data==null){
                    setPermitions([]);
                }
                for (let index = 0; index < data.data.data.length; index++) {
                    const element = data.data.data[index];
                    arrayTemp.push({
                        id: element.id,
                        roleId: element.roleId,
                        elementId: element.elementId
                    })
                }
                setPermitions(arrayTemp);
            })
            .catch((err) => {

            })
    }
    const handleUpdate = () => {

        api(SERVICE.getRoles)
            .then((data) => {
                let arrayTemp = [];
                setRolSelect(null);
                for (let index = 0; index < data.data.data.length; index++) {
                    const element = data.data.data[index];
                    arrayTemp.push({
                        id: element.id,
                        value: element.identifier,
                        label: element.description,
                        active: false
                    })
                }
                setRoles(arrayTemp);
            })
            .catch((err) => {

            })
    }
    const handleAddRol = () => {
        var message = "Agregar nuevo rol";

        Swal.fire({
            title: message,
            input: "text",
            inputAttributes: {
                autocapitalize: "off"
            },
            showCancelButton: true,
            confirmButtonText: "Enviar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            preConfirm: async (login) => {
                const payload = {
                    identifier: login,
                    description: login
                }
                api(SERVICE.insertRol, payload, "POST")
                    .then((data) => {
                        handleUpdate();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Guardado correctamente",
                    showConfirmButton: false,
                    timer: 1500
                });
            }
        });
    }
    const handleDeleteRol = () => {

        let message = "";
        message = "Esta segur@ que desea eliminar el rol '" + (rolSelect != null ? rolSelect.label : "") + "'?";

        Swal.fire({
            title: message,
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {

                api(SERVICE.deleteRol + `?RolesId=${rolSelect.id}`, {}, "DELETE")
                    .then((data) => {
                        handleUpdate();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        });

    }
    const handleUpdateElements = () => {
        api(SERVICE.getElements)
            .then((data) => {
                let arrayTemp = [];
                setRolSelect(null);
                for (let index = 0; index < data.data.data.length; index++) {
                    const element = data.data.data[index];
                    arrayTemp.push({
                        id: element.id,
                        identifier: element.identifier,
                        description: element.description,
                        active: false
                    })
                }
                setElementAll(arrayTemp);
                setElementUser(arrayTemp);
            })
            .catch((err) => {

            })
    }
    useEffect(() => {
        handleUpdate();
        handleUpdateElements();
        handleUpdatePermision();
    }, []);
    useEffect(() => {
        if (rolSelect != null) {
            let arrayTemp = [];
            for (let index = 0; index < elementsAll.length; index++) {
                const element = elementsAll[index];
                let searchElement = permitions.findIndex(item => item.elementId === element.id && item.roleId === rolSelect.id);
                let active = false;
                if (searchElement !== -1) {
                    active = true;
                }
                arrayTemp.push(
                    {
                        ...element,
                        active: active
                    }
                )
            }
            setElementUser(arrayTemp);
        }
    }, [rolSelect, permitions, elementsAll])
    useEffect(() => {
        if (elementsUser.length > 0) {

        }
    }, [elementsUser])
    return (
        <>
            <WindowLayout
                title="PERMISOS"
                route={["Configuración","permisos"]}
                icon={<FaBook />}
            >
                <div className='paperContainer'>
                    <div>
                        
                        <div className={styles.contentSection}>
                            <div className={styles.roleManagement}>
                                <div className={styles.sectionTitle}>
                                    <FaUserFriends className={styles.sectionIcon} />
                                    <h4>Administración de Roles y Permisos</h4>
                                </div>
                                
                                <div className={styles.roleControls}>
                                    <div className={styles.selectWrapper}>
                                        <label className={styles.selectLabel} style={{zIndex:9999}}>Seleccionar Rol:</label>
                                        <Select
                                            className={styles.select}
                                            classNamePrefix="select"
                                            value={rolSelect}
                                            onChange={(e) => setRolSelect(e)}
                                            name="roles"
                                            options={roles}
                                            isClearable={true}
                                            placeholder="Seleccione un rol..."
                                            styles={{
                                                control: (provided, state) => ({
                                                    ...provided,
                                                    width: "100%",
                                                    borderColor: state.isFocused ? '#007494' : '#dee2e6',
                                                    boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0, 116, 148, 0.25)' : 'none',
                                                    '&:hover': {
                                                        borderColor: '#007494'
                                                    }
                                                }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    backgroundColor: state.isSelected ? '#007494' : state.isFocused ? '#f8f9fa' : 'white',
                                                    color: state.isSelected ? 'white' : '#333'
                                                })
                                            }}
                                        />
                                    </div>
                                    <div className={styles.actionButtons}>
                                        <button 
                                            onClick={() => handleAddRol()} 
                                            className={`btn btn-success ${styles.actionBtn}`}
                                            title="Agregar nuevo rol"
                                        >
                                            <MdAddCircle className={styles.btnIcon} />&nbsp;Nuevo Rol
                                        </button>
                                        <button 
                                            onClick={() => handleDeleteRol()} 
                                            className={`btn btn-danger ${styles.actionBtn}`}
                                            disabled={!rolSelect}
                                            title="Eliminar rol seleccionado"
                                        >
                                            <MdDelete className={styles.btnIcon} />&nbsp;Eliminar
                                        </button>
                                    </div>
                                </div>

                                {/* Permissions Section - Integrated */}
                                {rolSelect && (
                                    <div className={styles.permissionsArea}>
                                        <div className={styles.permissionsHeader}>
                                            <FaBook className={styles.sectionIcon} />
                                            <h5>Permisos para: <span className={styles.roleName}>{rolSelect.label}</span></h5>
                                        </div>
                                        
                                        <div className={styles.permissionsContainer}>
                                            {/* Available Permissions */}
                                            <div className={styles.permissionColumn}>
                                                <div className={styles.columnHeader}>
                                                    <h6 className={styles.columnTitle}>Permisos Disponibles</h6>
                                                    <span className={styles.itemCount}>
                                                        {elementsUser.filter(item => !item.active).length} elementos
                                                    </span>
                                                </div>
                                                <div className={styles.itemsList}>
                                                    {elementsUser.map((item, index) => {
                                                        if (!item.active) {
                                                            return (
                                                                <div key={index} className={styles.permissionItem}>
                                                                    <div className={styles.itemInfo}>
                                                                        <span className={styles.itemName}>{item.description}</span>
                                                                        <span className={styles.itemId}>ID: {item.identifier}</span>
                                                                    </div>
                                                                    <button 
                                                                        onClick={() => handleAddElementUser(item.id)} 
                                                                        className={`btn btn-sm btn-outline-success ${styles.permissionBtn}`}
                                                                        title="Agregar permiso"
                                                                    >
                                                                        <FaPlus />
                                                                    </button>
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                    {elementsUser.filter(item => !item.active).length === 0 && (
                                                        <div className={styles.emptyState}>
                                                            <p>Todos los permisos han sido asignados</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Assigned Permissions */}
                                            <div className={styles.permissionColumn}>
                                                <div className={styles.columnHeader}>
                                                    <h6 className={styles.columnTitle}>Permisos Asignados</h6>
                                                    <span className={styles.itemCount}>
                                                        {elementsUser.filter(item => item.active).length} elementos
                                                    </span>
                                                </div>
                                                <div className={styles.itemsList}>
                                                    {elementsUser.map((item, index) => {
                                                        if (item.active) {
                                                            return (
                                                                <div key={index} className={styles.permissionItem}>
                                                                    <div className={styles.itemInfo}>
                                                                        <span className={styles.itemName}>{item.description}</span>
                                                                        <span className={styles.itemId}>ID: {item.identifier}</span>
                                                                    </div>
                                                                    <button 
                                                                        onClick={() => handleDeleteElementUser(item.id)} 
                                                                        className={`btn btn-sm btn-outline-danger ${styles.permissionBtn}`}
                                                                        title="Remover permiso"
                                                                    >
                                                                        <FaMinus />
                                                                    </button>
                                                                </div>
                                                            );
                                                        }
                                                        return null;
                                                    })}
                                                    {elementsUser.filter(item => item.active).length === 0 && (
                                                        <div className={styles.emptyState}>
                                                            <p>No hay permisos asignados</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {/* No Role Selected State */}
                                {!rolSelect && (
                                    <div className={styles.noRoleSelected}>
                                        <div className={styles.emptyStateIcon}>
                                            <FaUserFriends />
                                        </div>
                                        <h5>Selecciona un rol</h5>
                                        <p>Elige un rol de la lista para gestionar sus permisos y accesos del sistema.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </WindowLayout>

        </>
    );
} 